import react from "../../../assets/SkillsImage/react.png";
import reactNative from "../../../assets/SkillsImage/reactNative.png";
import nextJS from "../../../assets/SkillsImage/nextJS.png";
import nodejs from "../../../assets/SkillsImage/nodejs.png";
import vuejs from "../../../assets/SkillsImage/vuejs.png";
import express from "../../../assets/SkillsImage/express.png";
import javascript from "../../../assets/SkillsImage/javascript.jpeg";
import typescript from "../../../assets/SkillsImage/typescript.png";
import html from "../../../assets/SkillsImage/html.jpg";
import css from "../../../assets/SkillsImage/css.jpg";
import bootstrap5 from "../../../assets/SkillsImage/bootstrap5.jpeg";
import materailUI from "../../../assets/SkillsImage/materailUI.png";
import tailwindCSS from "../../../assets/SkillsImage/tailwindCSS.jpg";
import sass from "../../../assets/SkillsImage/sass.jpg";
import nativebase from "../../../assets/SkillsImage/nativebase.png";
import Mongodb from "../../../assets/SkillsImage/Mongodb.jpg";
import postman from "../../../assets/SkillsImage/postman.png";
import adobe from "../../../assets/SkillsImage/adobe.jpg";
import figma from "../../../assets/SkillsImage/figma.png";
import gitbash from "../../../assets/SkillsImage/gitbash.jpg";
import github from "../../../assets/SkillsImage/github.jpeg";
import gitlab from "../../../assets/SkillsImage/gitlab.png";

const skills = [
    { image: react, name: "React", level: "Expert" },
    { image: reactNative, name: "React Native", level: "Advanced" },
    { image: nextJS, name: "Next.js", level: "Advanced" },
    { image: nodejs, name: "Node.js", level: "Expert" },
    { image: vuejs, name: "Vue.js", level: "Elementary" },
    { image: express, name: "Express", level: "Expert" },
    { image: javascript, name: "JavaScript", level: "Expert" },
    { image: typescript, name: "TypeScript", level: "Intermediate" },
    { image: html, name: "HTML", level: "Expert" },
    { image: css, name: "CSS", level: "Expert" },
    { image: bootstrap5, name: "Bootstrap 5", level: "Advanced" },
    { image: materailUI, name: "Material UI", level: "Intermediate" },
    { image: tailwindCSS, name: "Tailwind CSS", level: "Intermediate" },
    { image: sass, name: "Sass", level: "Advanced" },
    { image: nativebase, name: "NativeBase", level: "Intermediate" },
    { image: Mongodb, name: "MongoDB", level: "Advanced" },
    { image: postman, name: "Postman", level: "Intermediate" },
    { image: adobe, name: "Adobe Photoshop", level: "Elementary" },
    { image: figma, name: "Figma", level: "Advanced" },
    { image: gitbash, name: "Git Bash", level: "Intermediate" },
    { image: github, name: "GitHub", level: "Expert" },
    { image: gitlab, name: "GitLab", level: "Intermediate" },
];

export default skills;